import { render, staticRenderFns } from "./ChildOrderTable.vue?vue&type=template&id=46f61ddd"
import script from "./ChildOrderTable.vue?vue&type=script&lang=js"
export * from "./ChildOrderTable.vue?vue&type=script&lang=js"
import style0 from "./ChildOrderTable.vue?vue&type=style&index=0&id=46f61ddd&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports